module.exports = __webpack_public_path__ + "img/img_boss_img1.b0d3a6e1.png";